"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vector2 = void 0;
class Vector2 {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    static copy(vec2) {
        return new Vector2(vec2.x, vec2.y);
    }
    static fromArray(numbers) {
        if (numbers.length !== 2) {
            throw new Error("");
        }
        return new Vector2(numbers[0], numbers[1]);
    }
    iterate2d(callback) {
        for (let yi = 0; yi < this.y; yi++) {
            for (let xi = 0; xi < this.x; xi++) {
                callback(xi, yi, new Vector2(xi, yi));
            }
        }
    }
    iterate1d(callback) {
        for (let yi = 0; yi < this.y; yi++) {
            for (let xi = 0; xi < this.x; xi++) {
                callback(yi * this.x + xi);
            }
        }
    }
    add(vec2) {
        return new Vector2(this.x + vec2.x, this.y + vec2.y);
    }
    subtract(vec) {
        return new Vector2(this.x - vec.x, this.y - vec.y);
    }
    area() {
        return this.x * this.y;
    }
    asMapKey() {
        if (this.stringKeyCache) {
            return this.stringKeyCache;
        }
        return this.stringKeyCache = `(${this.x}|${this.y})`;
    }
    equals(vec) {
        return this.x === vec.x && this.y === vec.y;
    }
    scalarMultiplicate(scalar) {
        return new Vector2(this.x * scalar, this.y * scalar);
    }
    scalarDivide(scalar) {
        return new Vector2(this.x / scalar, this.y / scalar);
    }
    elementDivide(vec) {
        return new Vector2(this.x / vec.x, this.y / vec.y);
    }
    elementMultiplicate(vec) {
        return new Vector2(this.x * vec.x, this.y * vec.y);
    }
    floor() {
        return new Vector2(Math.floor(this.x), Math.floor(this.y));
    }
    ceil() {
        return new Vector2(Math.ceil(this.x), Math.ceil(this.y));
    }
}
exports.Vector2 = Vector2;
//# sourceMappingURL=Vector2.js.map